import { useState, useEffect } from 'react';

interface ProfilePictureState {
  pictureUrl: string | null;
  loading: boolean;
  error: Error | null;
}

export const useProfilePicture = (
  firstName: string,
  lastName: string,
  linkedinUrl?: string,
  profilePicUrl?: string
) => {
  const [pictureUrl, setPictureUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadImage = async () => {
      try {
        setLoading(true);
        setError(null);

        // First try to use the provided profile picture URL
        if (profilePicUrl) {
          const img = new Image();
          img.src = profilePicUrl;
          await new Promise((resolve, reject) => {
            img.onload = resolve;
            img.onerror = reject;
          });
          setPictureUrl(profilePicUrl);
          return;
        }

        // If no profile picture URL is available, use initials
        setPictureUrl(null);
      } catch (err) {
        setError(err as Error);
        setPictureUrl(null);
      } finally {
        setLoading(false);
      }
    };

    loadImage();
  }, [firstName, lastName, linkedinUrl, profilePicUrl]);

  return { pictureUrl, loading, error };
}; 